export const isIE = (): boolean => {
  const { userAgent } = window.navigator;

  return userAgent.includes('MSIE ') || !!userAgent.match(/Trident.*rv\:11\./);
};
